// extracted by mini-css-extract-plugin
module.exports = {"container":"F9j9GRjs"};